import React from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";

const TEAM = [
  {
    name: "Fabio Palumbo",
    role: "Founder & DevOps Architect",
    grade: "SC",
    skills: ["AWS", "Kubernetes", "Terraform", "CI/CD"],
    project: "Dioscuro",
    availability: "On Project",
    bio: "15+ years building cloud infrastructure. Worked with Endava and PwC. Now building Dioscuro.",
  },
  {
    name: "Open Position",
    role: "Senior DevOps Engineer",
    grade: "SE",
    skills: ["K8s", "AWS", "Terraform"],
    project: "Available",
    availability: "Hiring",
    bio: "We're looking for someone who's been on-call enough times to know what matters.",
  },
  {
    name: "Open Position",
    role: "Junior DevOps Engineer",
    grade: "JT",
    skills: ["Linux", "Docker", "Git"],
    project: "Academy Graduate",
    availability: "Hiring",
    bio: "Fresh from our Academy program. Knows the fundamentals, ready to learn the rest.",
  },
];

const AVAILABILITY_COLORS = {
  Available: "var(--nd-success)",
  "On Project": "var(--nd-warning)",
  Hiring: "var(--nd-accent)",
};

const SectionStyled = styled.section`
  padding: 96px 0;
  background: var(--nd-black);
`;

const SectionLabel = styled.p`
  font-family: "Space Mono", monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nd-text-disabled);
  margin-bottom: 48px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  background: var(--nd-surface);
  border: 1px solid var(--nd-border);
  border-radius: 12px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

const Name = styled.h3`
  font-family: "Space Grotesk", sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: var(--nd-text-display);
  margin: 0;
`;

const Role = styled.p`
  font-family: "Space Grotesk", sans-serif;
  font-size: 14px;
  color: var(--nd-text-secondary);
  margin: 0;
`;

const GradeBadge = styled.span`
  font-family: "Space Mono", monospace;
  font-size: 11px;
  letter-spacing: 0.06em;
  padding: 4px 10px;
  border: 1px solid var(--nd-border-visible);
  border-radius: 999px;
  color: var(--nd-text-primary);
  white-space: nowrap;
`;

const Bio = styled.p`
  font-family: "Space Grotesk", sans-serif;
  font-size: 14px;
  color: var(--nd-text-secondary);
  line-height: 1.5;
  margin: 0;
`;

const SkillsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const SkillTag = styled.span`
  font-family: "Space Mono", monospace;
  font-size: 11px;
  letter-spacing: 0.04em;
  padding: 4px 10px;
  background: var(--nd-black);
  border: 1px solid var(--nd-border);
  border-radius: 6px;
  color: var(--nd-text-secondary);
`;

const MetaRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  border-top: 1px solid var(--nd-border);
`;

const ProjectLabel = styled.span`
  font-family: "Space Mono", monospace;
  font-size: 11px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--nd-text-disabled);
`;

const StatusDot = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: "Space Mono", monospace;
  font-size: 11px;
  letter-spacing: 0.04em;
  color: var(--nd-text-secondary);

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ color }) => color};
  }
`;

const PeopleOps = () => (
  <SectionStyled>
    <Container>
      <SectionLabel>TEAM DIRECTORY</SectionLabel>
      <Grid>
        {TEAM.map((member, i) => (
          <Card key={i}>
            <CardHeader>
              <div>
                <Name>{member.name}</Name>
                <Role>{member.role}</Role>
              </div>
              <GradeBadge>{member.grade}</GradeBadge>
            </CardHeader>
            <Bio>{member.bio}</Bio>
            <SkillsRow>
              {member.skills.map((skill) => (
                <SkillTag key={skill}>{skill}</SkillTag>
              ))}
            </SkillsRow>
            <MetaRow>
              <ProjectLabel>{member.project}</ProjectLabel>
              <StatusDot color={AVAILABILITY_COLORS[member.availability]} aria-label={`Availability: ${member.availability}`}>
                {member.availability}
              </StatusDot>
            </MetaRow>
          </Card>
        ))}
      </Grid>
    </Container>
  </SectionStyled>
);

export default PeopleOps;
